import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getSiteConfiguration } from '../../features/Configuration/configurationAction';
import {
  ActiveUserConfigCard,
  HighRiskAccountsConfig,
  EmailAlertSettingsCard,
  KPIScoreTrendsConfig,
} from '../../modules/Configuration';
import { PackageHeader } from '../../components/CustomHeading';
import useStyles from '../../hooks/useStyles';
import styles from '../../layouts/pages/style';
import CustomOrgNameCard from '../../modules/Configuration/components/CustomOrgName/CustomOrgNameCard';

function Configuration() {
  const dispatch = useDispatch();
  const classes = useStyles(styles)();

  useEffect(() => {
    dispatch(getSiteConfiguration());

    const { hash } = window.location;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <Grid container gap={2}>
      <Grid item xs={12} className={classes.cardStyles}>
        <PackageHeader noPackage heading="Configuration" />
      </Grid>

      <Grid container item xs={12} spacing={2}>
        {/* Email Alert */}
        <Grid container item xs={12}>
          <EmailAlertSettingsCard />
        </Grid>

        {/* Active User Config */}
        <Grid container item xs={12}>
          <ActiveUserConfigCard />
        </Grid>

        {/* Custom Organization Name */}
        <Grid container item xs={12}>
          <CustomOrgNameCard />
        </Grid>

        {/* KPI Score Trends */}
        <Grid container item xs={12}>
          <KPIScoreTrendsConfig />
        </Grid>

        {/* High-Risk Accounts Definition */}
        <Grid container item xs={12}>
          <HighRiskAccountsConfig />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Configuration;
